
export class Model {

  id: string;
  name: string;
  alias: string;
  modelDirectory: string;
  builderDirectory: string;
  publicReviewId: string;

  constructor(public data: any) {
    const json: JSON = data;

    this.id = json['id'];
    this.name = json['name'];
    this.alias = json['alias'];
    this.modelDirectory = json['model_directory'];
    this.builderDirectory = json['builder_directory'];
    this.publicReviewId = json['public_review_id'];
  }

  builderModelFolderPath() {
    return '/' + this.builderDirectory + '/' + this.modelDirectory;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/model.ts